
// (function () {
//   var DISCOUNT = 0.70;                 /* 30% off → pay 70% */
//   var WIDGET = '.appstle_sub_widget, #appstle_subscription_widget0';
//   var CHECK_EVERY = 400;
//   var GIVE_UP_AFTER = 30000;

//   /* Change text without replacing Appstle's own text node */
//   function setText(el, text) {
//     if (el.textContent.trim() === text) return false;          /* already right: no change, no loop */
//     var node = el.firstChild;
//     if (node && node.nodeType === 3 && el.childNodes.length === 1) node.nodeValue = text;
//     else el.textContent = text;
//     return true;
//   }

//   function initAppstleDiscount(widget) {
//     if (widget.dataset.discountInit) return;
//     widget.dataset.discountInit = '1';

//     var observer, queued = false;

//     function updateOneTimePrice() {
//       var wrapper = widget.querySelector('.appstle_one_time_details_wrapper');
//       if (!wrapper) return;
//       var price = wrapper.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount');
//       if (!price) return;

//       var current = price.textContent.trim();
//       if (!price.dataset.originalPrice || current !== price.dataset.appliedPrice) {
//         price.dataset.originalPrice = current;                  /* Appstle showed a new price */
//       }
//       var originalText = price.dataset.originalPrice;
//       var amount = parseFloat(originalText.replace(/[^0-9.]/g, ''));
//       if (!isFinite(amount)) return;

//       var currency = (originalText.match(/^[^\d]*/) || [''])[0] || '$';
//       var newPrice = currency + (amount * DISCOUNT).toFixed(2);
//       price.dataset.appliedPrice = newPrice;

//       /* Pause watching while we write, so our own change doesn't trigger another run */
//       observer.disconnect();
//       setText(price, newPrice);
//       var sr = wrapper.querySelector('.appstle_subscription_amount-appstle-sr-only');
//       if (sr) setText(sr, 'Discounted price ' + newPrice);
//       observer.observe(widget, { childList: true, subtree: true, characterData: true });
//     }

//     /* Run at most once per frame, after Appstle has finished updating */
//     function schedule() {
//       if (queued) return;
//       queued = true;
//       requestAnimationFrame(function () { queued = false; updateOneTimePrice(); });
//     }

//     observer = new MutationObserver(schedule);
//     observer.observe(widget, { childList: true, subtree: true, characterData: true });
//     updateOneTimePrice();
//   }

//   var waited = 0;
//   var timer = setInterval(function () {
//     var widget = document.querySelector(WIDGET);
//     if (widget) { clearInterval(timer); initAppstleDiscount(widget); return; }
//     waited += CHECK_EVERY;
//     if (waited >= GIVE_UP_AFTER) clearInterval(timer);
//   }, CHECK_EVERY);
// })();


(function () {
  let attempts = 0;
  let timer;

  function updateOneTimePrice() {
    const wrappers = document.querySelectorAll(
      '.appstle_one_time_details_wrapper'
    );

    wrappers.forEach(function (wrapper) {
      const widget = wrapper.closest(
        '.appstle_subscription_wrapper'
      );

      if (!widget) return;

      const price = wrapper.querySelector(
        '.appstle_one_time_price_wrapper .appstle_subscription_amount'
      );

      const badge = widget.querySelector(
        '.appstle-save-badge'
      );

      if (!price || !badge) return;

      const match = badge.textContent.match(
        /(\d+(?:\.\d+)?)\s*%/
      );

      if (!match) return;

      const discount = parseFloat(match[1]);

      const originalText =
        price.dataset.originalPrice || price.textContent.trim();

      const originalAmount = parseFloat(
        originalText.replace(/[^0-9.]/g, '')
      );

      if (!Number.isFinite(originalAmount)) return;

      price.dataset.originalPrice = originalText;

      const discounted = (
        originalAmount * (1 - discount / 100)
      ).toFixed(2);

      const currency =
        originalText.match(/^[^\d]*/)?.[0] || '$';

      const finalPrice = currency + discounted;

      if (price.textContent.trim() !== finalPrice) {
        price.textContent = finalPrice;
      }
    });
  }

  function init() {
    updateOneTimePrice();

    document.addEventListener('change', function (event) {
      if (
        event.target.matches(
          '#appstle_subscription_widget0 input[name="selling_plan"]'
        )
      ) {
        setTimeout(updateOneTimePrice, 100);
        setTimeout(updateOneTimePrice, 500);
      }
    });
  }

  timer = setInterval(function () {
    attempts++;

    if (
      document.querySelector('.appstle_one_time_details_wrapper')
    ) {
      clearInterval(timer);
      init();
    }

    if (attempts >= 40) {
      clearInterval(timer);
    }
  }, 500);

})();
